module.exports = __webpack_public_path__ + "static/media/avax-start-lp.69ccb2f3.png";